import { trackEvent } from "@src/utils/trackEvent"

type WithdrawSurface = "default" | "fund"

export function trackUniversalSendRequested(surface: WithdrawSurface) {
  if (surface === "default") trackEvent("universal_send_requested")
}

export function trackUniversalSendRejected(
  surface: WithdrawSurface,
  reason: string | undefined
) {
  if (
    surface === "default" &&
    reason != null &&
    ["ERR_USER_DIDNT_SIGN", "ERR_WALLET_CANCEL_ACTION"].includes(reason)
  ) {
    trackEvent("universal_send_rejected")
  }
}
